import { getLocaleTimezoneIsoDate } from '@skytech/utils'

import type { Customer, AssetExtended, Employee } from '@/modules/admin/resources'

export function getInitialValues(assetDetails: AssetExtended, costObjectList: Employee[]) {
  const costObject = costObjectList.find(costObject => costObject.id === assetDetails.costObjectId)
  return {
    userName: (costObject && `${costObject.name} - ${costObject.code}`) || '',
    costObjectId: assetDetails.costObjectId,
    customerAddressId: assetDetails.customerAddressId || '',
    comment: assetDetails.comment || '',
    cost: assetDetails.cost || 0,
    customerId: assetDetails.customerId,
    assetDescription: assetDetails.assetDescription || '',
    imei: assetDetails.imei || '',
    snr: assetDetails.snr || '',
    ownershipTypeId: assetDetails.ownershipTypeId,
    received: assetDetails.received ? getLocaleTimezoneIsoDate(assetDetails.received) : '',
    statusId: assetDetails.statusId,
    typeId: assetDetails.typeId,
    userTypeId: assetDetails.userTypeId,
    deleteCertificate: assetDetails.deleteCertificate,
    deleteCertificateDate: assetDetails.deleteCertificateDate
      ? getLocaleTimezoneIsoDate(assetDetails.deleteCertificateDate)
      : '',
    leaseStart: assetDetails.leaseStart ? getLocaleTimezoneIsoDate(assetDetails.leaseStart) : '',
    leaseEnd: assetDetails.leaseEnd ? getLocaleTimezoneIsoDate(assetDetails.leaseEnd) : '',
    resultCost: assetDetails.resultCost,
    result: assetDetails.result,
    returnStatusId: assetDetails.returnStatusId,
    ecomPolicyId: assetDetails.policyId,
    conditionDesc: assetDetails.conditionDesc || '',
  }
}

export const getSelectedCustomerId = (customerName: string, customers?: Customer[]) =>
  customers?.find(customer => `${customer.name} ${customer.orgNo}` === customerName)?.id

export const getCostObjectById = (costObjectList: Employee[], costObjectId: number) =>
  costObjectList.find(costObject => costObject.id === costObjectId)
